import React, { Component } from 'react';
import SnoozedListItem from '../../components/SnoozedListItem';

const dateUtil = require('../../../../utils/dateUtil/dateUtil');
const translator = require('../../../../utils/translator/translator');


class SnoozeCard extends Component
{
    render()
    {
        const snooze = this.props.data;

        const caption = snooze.expiry != "-1"
            ? `${translator.getLabel('snoozed_till')} ${dateUtil.formatDate(dateUtil.convertToLocalStandard(snooze.expiry), "dddd, HH:mm")}`
            : translator.getLabel('snoozed_till_manual');

        return (
            <SnoozedListItem style={{marginBottom:"16px"}}
                caption={snooze.isSnoozed ? caption : (
                    <div>
                        <span style={{ textDecoration: "line-through" }}>
                            {caption}
                        </span>
                        <span style={{ color: 'green', fontWeight: 'bold', marginLeft: '1rem' }}>
                            {translator.getLabel('available_now')}
                        </span>
                    </div>

                )}
                snoozePayload={{ 'operator': snooze.operator }}
                rowData={[
                    {
                        'label': translator.getLabel('dispatch_type'),
                        'value': snooze.dispatchTypes.length > 0 ? snooze.dispatchTypes[0] : translator.getLabel('all')
                    },
                    {
                        'label': translator.getLabel('venue'),
                        'value': snooze.venueCodes.length > 0 ? snooze.venueCodes[0] : translator.getLabel('all')
                    },
                    {
                        'label': translator.getLabel('channel'),
                        'value': snooze.channel != null ? snooze.channel : translator.getLabel('all')
                    }
                ]}
                Footer=
                {
                    snooze.isSnoozed ?
                        <span style={{ fontSize: "1.1em" }} className="m-2 badge bg-danger" onClick={() => this.props.onDelete(snooze)}>{translator.getLabel('unsnooze')}</span>
                        :
                        <span style={{ fontSize: "1.1em" }} className="m-2 badge bg-success" onClick={() => this.props.onUndo(snooze)}>{translator.getLabel('snooze')}</span>
                }
            />
        );
    }
}

export default SnoozeCard;